import React from 'react';
import type { MessengerTransport } from '../../types/whatsapp.types';

interface TransportIconProps {
  transport?: MessengerTransport | null;
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

/** Иконка WhatsApp */
const WhatsAppSvg: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path fill="#25D366" d="M.057 24l1.687-6.163A11.867 11.867 0 0112.02 0c6.574 0 11.91 5.338 11.91 11.922c0 6.585-5.336 11.923-11.91 11.923a11.9 11.9 0 01-6.1-1.67L.057 24z"/>
    <path fill="#fff" d="M17.53 13.87c-.1-.06-1.71-.84-1.97-.94c-.26-.1-.45-.15-.64.1c-.19.26-.74.94-.91 1.13c-.17.2-.34.22-.63.08c-.29-.15-1.23-.45-2.34-1.49c-.86-.77-1.44-1.7-1.61-1.98c-.17-.29-.02-.45.13-.6c.13-.13.29-.34.43-.51c.14-.17.19-.29.29-.49c.1-.2.05-.37-.02-.51c-.06-.14-.64-1.54-.88-2.1c-.23-.56-.47-.49-.64-.5c-.17-.01-.37-.01-.57-.01c-.2 0-.51.07-.78.37c-.27.29-1.03 1-1.03 2.44s1.06 2.83 1.21 3.03c.15.2 2.09 3.19 5.06 4.47c.71.31 1.27.49 1.71.62c.72.23 1.38.2 1.9.12c.58-.09 1.71-.7 1.95-1.37c.24-.67.24-1.25.17-1.37c-.07-.12-.18-.18-.28-.24z"/>
  </svg>
);

/** Иконка Telegram */
const TelegramSvg: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <circle cx="12" cy="12" r="12" fill="#2AABEE"/>
    <path fill="#fff" d="M5.432 11.873c3.498-1.524 5.83-2.529 6.998-3.014 3.333-1.387 4.025-1.627 4.476-1.635.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.064-1.225-.46-1.9-.903-1.056-.693-1.653-1.124-2.678-1.8-1.185-.782-.417-1.212.258-1.914.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212-.07-.063-.174-.042-.249-.025-.106.024-1.793 1.14-5.061 3.346-.479.329-.913.489-1.302.48-.429-.008-1.252-.242-1.865-.442-.75-.244-1.349-.374-1.297-.79.027-.216.325-.437.893-.663z"/>
  </svg>
);

/** Иконка Instagram */
const InstagramSvg: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#FFDC80"/>
        <stop offset="25%" stopColor="#F77737"/>
        <stop offset="50%" stopColor="#E1306C"/>
        <stop offset="75%" stopColor="#C13584"/>
        <stop offset="100%" stopColor="#5851DB"/>
      </linearGradient>
    </defs>
    <rect width="24" height="24" rx="6" fill="url(#ig-grad)"/>
    <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" stroke="#fff" strokeWidth="1.5" fill="none"/>
    <circle cx="12" cy="12" r="4" stroke="#fff" strokeWidth="1.5" fill="none"/>
    <circle cx="17.5" cy="6.5" r="1.2" fill="#fff"/>
  </svg>
);

/** Иконка TikTok */
const TikTokSvg: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <rect width="24" height="24" rx="6" fill="#010101" />
    <path
      fill="#FFFFFF"
      d="M16.6 6.2c-.62-.71-.96-1.62-.96-2.56h-2.3v9.96c0 1.2-.98 2.18-2.18 2.18a2.18 2.18 0 1 1 .64-4.27V9.16a4.48 4.48 0 1 0 3.84 4.43V8.66c.86.62 1.9.95 2.96.95V7.31c-.74 0-1.45-.3-1.97-.83l-.07-.28z"
    />
    <path
      fill="#25F4EE"
      d="M11.16 13.6a1.45 1.45 0 0 0-1.04 2.46 1.45 1.45 0 0 1 1.68-2.42v-.02a4.48 4.48 0 0 0-.64-.02z"
      opacity="0.0"
    />
  </svg>
);

/** Иконка Avito */
const AvitoSvg: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <rect width="24" height="24" rx="6" fill="#00AAFF"/>
    <text x="12" y="16.5" textAnchor="middle" fill="#fff" fontSize="12" fontWeight="700" fontFamily="sans-serif">A</text>
  </svg>
);

/** Иконка VK */
const VkSvg: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <rect width="24" height="24" rx="6" fill="#0077FF"/>
    <path fill="#fff" d="M12.79 16.52h.86s.26-.03.39-.17c.12-.13.12-.37.12-.37s-.02-1.14.51-1.31c.53-.16 1.2 1.08 1.92 1.56.54.36.96.28.96.28l1.93-.03s1.01-.06.53-.84c-.04-.06-.28-.58-1.45-1.64-1.23-1.1-1.06-.93.41-2.84.9-1.16 1.26-1.87 1.15-2.18-.11-.29-.77-.21-.77-.21l-2.17.01s-.16-.02-.28.05c-.12.07-.19.23-.19.23s-.35.93-.81 1.72c-.98 1.67-1.37 1.76-1.53 1.65-.37-.24-.28-1-.28-1.53 0-1.67.25-2.36-.5-2.54-.25-.06-.43-.1-1.07-.1-.82-.01-1.51 0-1.9.19-.26.13-.46.42-.34.44.15.02.5.09.68.34.24.32.23 1.05.23 1.05s.14 1.96-.32 2.2c-.31.17-.74-.17-1.66-1.7-.47-.78-.82-1.65-.82-1.65s-.07-.17-.19-.26c-.15-.11-.36-.15-.36-.15l-2.06.01s-.31.01-.42.14c-.1.12-.01.36-.01.36s1.63 3.82 3.47 5.75c1.69 1.77 3.61 1.65 3.61 1.65z"/>
  </svg>
);

/** Иконка Viber */
const ViberSvg: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <rect width="24" height="24" rx="6" fill="#7360F2"/>
    <path fill="#fff" d="M16.41 3.37a10.66 10.66 0 00-8.82 0C5.24 4.58 4 6.73 4 9.14v1.72c0 2.41 1.24 4.56 3.59 5.77a10.13 10.13 0 003.21 1.14v2.23l2.96-2.13a10.56 10.56 0 002.65-1.24c2.35-1.21 3.59-3.36 3.59-5.77V9.14c0-2.41-1.24-4.56-3.59-5.77zm-.52 8.56l-1.14 1.14a1.09 1.09 0 01-.91.31 6.4 6.4 0 01-3.06-1.56 6.4 6.4 0 01-1.56-3.06 1.09 1.09 0 01.31-.91l1.14-1.14a.52.52 0 01.73 0l1.14 1.14a.52.52 0 010 .73l-.57.57a3.34 3.34 0 001.19 1.19l.57-.57a.52.52 0 01.73 0l1.14 1.14a.52.52 0 01.29.02z"/>
  </svg>
);

/** Фоллбэк — стандартная иконка сообщений */
const DefaultSvg: React.FC<{ size: number }> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" aria-hidden>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
  </svg>
);

const ICON_MAP: Record<string, React.FC<{ size: number }>> = {
  whatsapp: WhatsAppSvg,
  telegram: TelegramSvg,
  instagram: InstagramSvg,
  tiktok: TikTokSvg,
  avito: AvitoSvg,
  vk: VkSvg,
  viber: ViberSvg,
};

/**
 * Иконка транспорта (мессенджера).
 * Показывает брендовую SVG иконку для WhatsApp, Telegram, Instagram и др.
 */
const TransportIcon: React.FC<TransportIconProps> = ({ transport, size = 20, className, style }) => {
  const key = (transport || '').toLowerCase();
  const IconComponent = ICON_MAP[key] || DefaultSvg;

  return (
    <span
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, ...style }}
    >
      <IconComponent size={size} />
    </span>
  );
};

export default TransportIcon;
